import PlayCircleRounded from '@mui/icons-material/PlayCircleRounded';

export const StartTimeTrackingCircledIcon = PlayCircleRounded;
